import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { OtherUserPermittedFunctions } from "@/commons/models/OtherUserGroup";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 施設関係者グループメールメンバー API 操作クラス
 */
export default class MailOtherUserGroupMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST MailOtherUserGroupMembers
   */
  public async post(userStore: LoginUser, groupId: number, model: MailOtherUserGroupMembersPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      groupId: groupId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MailOtherUserGroupMembers, formatParams);

    const response = await this.commonService.executePost<any>(userStore, requestUrl, model, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH MailOtherUserGroupMembers
   */
  public async patch(userStore: LoginUser, groupId: number, memberId: number, model: MailOtherUserGroupMembersPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      groupId: groupId,
      memberId: memberId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MailOtherUserGroupMember, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, model, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface MailOtherUserGroupMembersPostModel {
  memberMailaddress: string;
  memberName: string;
  memberTel: string;
  memberOrganization?: string;
}

export interface MailOtherUserGroupMembersPatchModel {
  /** 変更後グループID */
  groupId: number;
  /** メンバーメールアドレス */
  memberMailaddress: string;
  /** メンバー名 */
  memberName: string;
  /** メンバー電話番号 */
  memberTel: string;
  /** メンバー組織名 */
  memberOrganization?: string;
  /** 施設関係者メンバー個別機能使用可否設定 */
  otherUserPermittedFunctions: OtherUserPermittedFunctions;
  /** 整合性チェック用更新日時 */
  updated: number;
}
